<template>
  <v-menu v-model="checkInMenuOpened"
          :close-on-content-click="false"
          min-width="75%"
          left
          offset-y>
    <template v-slot:activator="{on, attrs}">
      <v-btn v-bind="attrs"
             v-on="on"
             block>
        {{ $t('admin_acc_gym_subscription.check_in_title') }}
      </v-btn>
    </template>

    <v-card outlined style="border-width: 4px;">
      <v-card-title class="blue-grey white--text">{{ $t('admin_acc_gym_subscription.check_in_title') }}</v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <v-text-field outlined
                          :label="$t('gym_subscription.reference_number')"
                          v-model="checkInReferenceNumber"
                          @input="checkReferenceNumber"
                          @keydown.enter="getGymPass"
                          autofocus></v-text-field>
          </v-col>
        </v-row>
        <v-row v-if="subscription">
          <v-col>
            <v-container fluid>
              <!--              <v-row>-->
              <!--                <v-col>-->
              <!--                  <label v-html="$t('gym_subscription.title')"></label>-->
              <!--                </v-col>-->
              <!--              </v-row>-->
              <!--              <v-divider></v-divider>-->
              <v-row>
                <v-col>
                  <v-row>
                    <v-col>
                      <v-text-field readonly
                                    :label="$t('gym_subscription.reference_number')"
                                    :value="subscription.reference_number.toString().padStart(10, '0')"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-text-field readonly
                                    :label="$t('gym_subscription.account')"
                                    :value="$t('name', {given_name: subscription.account.given_name, surname: subscription.account.surname})"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="hkiarace_account">
                    <v-col>
                      <v-text-field readonly
                                    :label="$t('my_account.acc_membership_valid_until')"
                                    :value="$parseDate(hkiarace_account.acc_membership_valid_until)"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-text-field readonly
                                    :label="$t('gym_subscription.status')"
                                    :value="subscriptionStatus"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-text-field readonly
                                    :label="$t('gym_subscription.type')"
                                    :value="subscription.type.name"></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col>
                  <v-row>
                    <v-col>
                      <v-btn @click="checkIn" block>
                        {{ $t('gym_subscription.checkin_time') }}
                      </v-btn>
                    </v-col>
                    <!--                    <v-col>-->
                    <!--                      <v-btn @click="checkOut" block>-->
                    <!--                        {{ $t('gym_subscription.checkout_time') }}-->
                    <!--                      </v-btn>-->
                    <!--                    </v-col>-->
                  </v-row>
                  <v-row>
                    <v-col v-if="showCheckInRecords">
                      <GymSubscriptionCheckInRecordList :subscription-id="subscription.id"
                                                        is-admin></GymSubscriptionCheckInRecordList>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
      </v-card-text>
      <!--      <v-card-actions>-->
      <!--        <v-spacer></v-spacer>-->
      <!--        <v-btn text color="#2bc7ca"-->
      <!--               @click="addAdhocWeekScheduleMenuOpened = false">-->
      <!--          {{ $t('cancel') }}-->
      <!--        </v-btn>-->
      <!--        <v-btn text color="#2bc7ca">-->
      <!--          {{ $t('save') }}-->
      <!--        </v-btn>-->
      <!--      </v-card-actions>-->
    </v-card>
  </v-menu>
</template>

<script>
import {computed, ref} from '@vue/composition-api'
import GymSubscriptionCheckInRecordList from "@/components/acc_booking/GymSubscriptionCheckInRecordList";
import {BOOKING_STATUS_LABEL} from "@/constants";

export default {
  name: 'GymPassCheckInButton',
  components: {GymSubscriptionCheckInRecordList},
  setup(props, {root}) {
    const checkInMenuOpened = ref(false);
    const checkInReferenceNumber = ref('');
    const checkReferenceNumber = function () {
      if (checkInReferenceNumber.value.length === 10) {
        getGymPass();
      }
    };

    const hkiarace_account = ref(null);
    const subscription = ref(null);
    const subscriptionStatus = computed(() => {
      return subscription.value ? root.$t(BOOKING_STATUS_LABEL[subscription.value.status]) : '';
    })
    const getGymPass = function () {
      subscription.value = null;
      checkInReferenceNumber.value = checkInReferenceNumber.value.toString().padStart(10, '0')
      root.$callAPI('aafb/admin/gym_subscription/', {reference_number: checkInReferenceNumber.value}, function (response) {
        subscription.value = response.body.subscription;
        hkiarace_account.value = response.body.hkiarace_account;
      });
    };

    const showCheckInRecords = ref(true);
    const checkIn = function () {
      root.$callAPI('aafb/admin/gym_subscription/checkin/', {subscription_id: subscription.value.id}, function (response) {
        showCheckInRecords.value = false;
        setTimeout(() => {
          showCheckInRecords.value = true;
        }, 50);
      });
    };
    const checkOut = function () {
      root.$callAPI('aafb/admin/gym_subscription/checkout/', {subscription_id: subscription.value.id}, function (response) {
        showCheckInRecords.value = false;
        setTimeout(() => {
          showCheckInRecords.value = true;
        }, 50);
      });
    };

    return {
      checkInMenuOpened,
      checkInReferenceNumber,
      checkReferenceNumber,
      getGymPass,
      hkiarace_account,
      subscription,
      subscriptionStatus,
      showCheckInRecords,
      checkIn,
      checkOut,
    }
  }
}
</script>
